import * as React from 'react';
import {
    Box,
    Link,
    Typography
} from "@mui/material";
import "../styles/pages/login-page.scss";

export const LoginPage = () => (
    <div className="container">
        <div className="content" style={{ minWidth: '690px', minHeight: '85vh' }}>

            <Box sx={{ flexGrow: 1 }}
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="80vh"
            >

                <div style={{ textAlign: "center" }}>
                    <h1>Log In to Your Account </h1>
                    <div>
                        <div
                            style={{
                                margin: "50px auto",                               
                                display: "grid",
                                gridTemplateColumns: " 1fr",
                                gap: "5px",
                            }}
                        >
                            <Typography variant="h5" noWrap component="div">
                                Click to <Link href="/">Log In</Link>
                            </Typography>
                          
                        </div>
                    </div>
                </div>
            </Box>

        </div>
    </div>
);

